import { showModal } from "app/modules/modal-management/reducer/action";
import i18n from "app/shared/language/i18n";
import store from "../store/store";
export const globalShowFuture = () => {
  store.dispatch(
    showModal({
      modalProps: {
        open: true,
        message: i18n.t("COMMON_CHUC_NANG_SAP_RA_MAT"),
      },
      modalType: "alert",
    }),
  );
};

export const globalShowDialog = (msg: string) => {
  // COMMON_CHUC_NANG_SAP_RA_MAT
  // COMMON_THONG_BAO_CHUC_NANG_DOI_MK
  // COMMON_THONG_BAO_CHUC_NANG_TAM_KHOA
  store.dispatch(
    showModal({
      modalProps: {
        open: true,
        message: msg,
      },
      modalType: "alert",
    }),
  );
};
